import {cloneDeep} from "lodash/lang";

export default class TemplatesDetailsController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        this.workflows = this.injector.get('Workflows');
        this.stateParams = this.injector.get('$stateParams');
        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.state = this.injector.get('$state');
        this.navService = this.injector.get('NavService');
        this.acl = this.injector.get('Acl');
        this.translate = this.injector.get('$translate');

        this.template = null;
        this.loading = true;
        this.numberCircles = true;
    }

    $onInit() {
        this._loadTemplate();
    }

    _decorateBreadcrumb() {
        this.navService.setStateParameters('app.vouchers.templates.details', {
            id: this.template.id
        });

        this.navService.setBreadcrumbParameters({
            template_name: this.template.name
        });
    }

    _loadTemplate() {
        this.loading = true;

        return this.api.get(`vouchers/templates/${this.stateParams.id}`)
            .then(({data}) => {
                this.template = data.data;
                this.numberCircles = _.cloneDeep(this.template.number_circles)
                this.loading = false;

                this._decorateBreadcrumb();
            })
            .catch((exception) => {
                this.alert.handle(exception);
            });
    }

    saveNumberCircle(numberCircle) {
        this.loading = true;

        return this.api.put(`vouchers/templates/number-circles/${numberCircle.id}`, {
            ...numberCircle
        })
            .then(({data}) => {
                this._loadTemplate();

                this._decorateBreadcrumb();
            })
            .catch((exception) => {
                this.alert.handle(exception);
            });
    }
}

TemplatesDetailsController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/templates/controllers/details-controller.js